import { db } from './firebase.js';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export async function updateSetCompletion(userId: string, setName: string, isComplete: boolean): Promise<void> {
  if (!db || !userId || !setName) return;
  const ref = doc(db, 'users', userId, 'app', 'completion');
  await setDoc(ref, { [setName]: isComplete, updatedAt: serverTimestamp() }, { merge: true });
  try {
    const snap = await getDoc(ref);
    const data = snap.exists() ? (snap.data() as Record<string, any>) : {};
    const count = Object.entries(data).reduce((acc, [k, v]) => (k !== 'updatedAt' && v === true ? acc + 1 : acc), 0);
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, { stats: { setsCompleted: count }, updatedAt: serverTimestamp() }, { merge: true });
  } catch {
    // ignore count failures; completion flag still stored
  }
}


